// blobStore.js - 2026-10-25 (S1)
// Billeder i offline-køerne (turbilleder og vejesedler) gemmes i telefonens
// IndexedDB i stedet for localStorage. localStorage har kun ~5 MB på iPhone,
// og et billede fylder ~250 KB - 10-15 billeder uden net, og køen var fuld.
// Før blev de ældste handlinger så slettet (fx morgenens ind-stempling).
// IndexedDB har langt mere plads; er den også fuld, afvises det NYE billede
// med en besked - der slettes aldrig noget, der venter.

const DB_NAME = "cf-offline";
const STORE = "blobs";
let dbPromise = null;
let backend = null;   // kun til test: { put, get, del } i hukommelsen

function openDb() {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve, reject) => {
    if (typeof indexedDB === "undefined") { reject(new Error("IndexedDB findes ikke")); return; }
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  dbPromise.catch(() => { dbPromise = null; });
  return dbPromise;
}

async function run(mode, fn) {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, mode);
    const req = fn(tx.objectStore(STORE));
    tx.oncomplete = () => resolve(req ? req.result : undefined);
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error || new Error("Telefonen har ikke plads"));
  });
}

export const putBlob = (key, value) => (backend ? backend.put(key, value) : run("readwrite", (s) => s.put(value, key)));
export const getBlob = (key) => (backend ? backend.get(key) : run("readonly", (s) => s.get(key)));
export const delBlob = (key) => (backend ? backend.del(key) : run("readwrite", (s) => s.delete(key))).catch(() => {});

/** Kun til test. */
export function setBlobBackend(b) { backend = b; }
